export const marketGainersData =[
    {
      "symbol": "SRAX",
      "name": "SRAX, Inc.",
      "change": 0.14,
      "price": 0.19,
      "changesPercentage": 280
    },
    {
      "symbol": "AUUD",
      "name": "Auddia Inc.",
      "change": 2.98,
      "price": 4.41,
      "changesPercentage": 208.3916
    },
    {
      "symbol": "LGVN",
      "name": "Longeveron Inc.",
      "change": 1.6,
      "price": 3.8,
      "changesPercentage": 72.7273
    },
    {
      "symbol": "ANL",
      "name": "Adlai Nortye Ltd. American Depositary Shares",
      "change": 5.5,
      "price": 13.85,
      "changesPercentage": 65.8683
    },
    {
      "symbol": "SMFL",
      "name": "Smart for Life, Inc.",
      "change": 0.2541,
      "price": 0.75,
      "changesPercentage": 52.2947
    },
    {
      "symbol": "DXYZ",
      "name": "Destiny Tech100 Inc.",
      "change": 24.41,
      "price": 83.61,
      "changesPercentage": 41.2331
    },
    {
      "symbol": "UCAR",
      "name": "U Power Limited",
      "change": 1.83,
      "price": 6.53,
      "changesPercentage": 39.6104
    },
    {
      "symbol": "ETAO",
      "name": "ETAO International Co., Ltd.",
      "change": 0.93,
      "price": 3.36,
      "changesPercentage": 38.2716
    },
    {
      "symbol": "CNXA",
      "name": "Connexa Sports Technologies Inc.",
      "change": 0.1056,
      "price": 0.4054,
      "changesPercentage": 35.2235
    },
    {
      "symbol": "JVSAR",
      "name": "JV SPAC Acquisition Corp. Right",
      "change": 0.09,
      "price": 0.35,
      "changesPercentage": 34.6154
    },
    {
      "symbol": "SUUN",
      "name": "SolarBank Corporation Common Stock",
      "change": 1.75,
      "price": 7,
      "changesPercentage": 33.3333
    },
    {
      "symbol": "AGRX",
      "name": "Agile Therapeutics, Inc.",
      "change": 0.079,
      "price": 0.369,
      "changesPercentage": 27.2414
    },
    {
      "symbol": "PTN",
      "name": "Palatin Technologies, Inc.",
      "change": 0.468,
      "price": 2.228,
      "changesPercentage": 26.5909
    },
    {
      "symbol": "FFIE",
      "name": "Faraday Future Intelligent Electric Inc.",
      "change": 0.0185,
      "price": 0.0969,
      "changesPercentage": 23.4474
    },
    {
      "symbol": "OM",
      "name": "Outset Medical, Inc.",
      "change": 0.465,
      "price": 2.515,
      "changesPercentage": 22.6829
    },
    {
      "symbol": "AIRC",
      "name": "Apartment Income REIT Corp.",
      "change": 7.08,
      "price": 38.43,
      "changesPercentage": 22.5801
    },
    {
      "symbol": "AXTI",
      "name": "AXT, Inc.",
      "change": 0.685,
      "price": 3.795,
      "changesPercentage": 21.9989
    },
    {
      "symbol": "ALAR",
      "name": "Alarum Technologies Ltd.",
      "change": 5.22,
      "price": 29.35,
      "changesPercentage": 21.6328
    },
    {
      "symbol": "DOGZ",
      "name": "Dogness (International) Corporation",
      "change": 1.68,
      "price": 9.73,
      "changesPercentage": 20.6894
    },
    {
      "symbol": "PPTA",
      "name": "Perpetua Resources Corp.",
      "change": 0.965,
      "price": 5.725,
      "changesPercentage": 20.2637
    },
    {
      "symbol": "ALCC",
      "name": "AltC Acquisition Corp.",
      "change": 2.5801,
      "price": 15.6801,
      "changesPercentage": 19.6954
    },
    {
      "symbol": "MMAT",
      "name": "Meta Materials Inc.",
      "change": 0.5835,
      "price": 3.6935,
      "changesPercentage": 18.7235
    },
    {
      "symbol": "KULR",
      "name": "KULR Technology Group, Inc.",
      "change": 0.1092,
      "price": 0.6947,
      "changesPercentage": 18.6539
    },
    {
      "symbol": "REED",
      "name": "Reed's, Inc.",
      "change": 0.29,
      "price": 1.85,
      "changesPercentage": 18.5897
    },
    {
      "symbol": "CXAI",
      "name": "CXApp Inc.",
      "change": 0.9003,
      "price": 5.8503,
      "changesPercentage": 18.1644
    },
    {
      "symbol": "CURI",
      "name": "CuriosityStream Inc.",
      "change": 0.1701,
      "price": 1.2001,
      "changesPercentage": 16.5162
    },
    {
      "symbol": "MESO",
      "name": "Mesoblast Limited",
      "change": 0.9555,
      "price": 6.7555,
      "changesPercentage": 16.4741
    },
    {
      "symbol": "MYTE",
      "name": "MYT Netherlands Parent B.V.",
      "change": 0.54,
      "price": 3.86,
      "changesPercentage": 16.4134
    },
    {
      "symbol": "IBIO",
      "name": "iBio, Inc.",
      "change": 0.34,
      "price": 2.45,
      "changesPercentage": 16.1897
    },
    {
      "symbol": "GLMD",
      "name": "Galmed Pharmaceuticals Ltd.",
      "change": 0.0545,
      "price": 0.3945,
      "changesPercentage": 16.0294
    },
    {
      "symbol": "TSVT",
      "name": "2seventy bio, Inc.",
      "change": 0.7804,
      "price": 5.7004,
      "changesPercentage": 15.8631
    },
    {
      "symbol": "AMRK",
      "name": "A-Mark Precious Metals, Inc.",
      "change": 5.07,
      "price": 37.8,
      "changesPercentage": 15.4904
    },
    {
      "symbol": "RNXT",
      "name": "RenovoRx, Inc.",
      "change": 0.18,
      "price": 1.35,
      "changesPercentage": 15.3846
    },
    {
      "symbol": "HRYU",
      "name": "Hanryu Holdings, Inc.",
      "change": 0.0331,
      "price": 0.2498,
      "changesPercentage": 15.2746
    },
    {
      "symbol": "CVU",
      "name": "CPI Aerostructures, Inc.",
      "change": 0.35,
      "price": 2.68,
      "changesPercentage": 15.0215
    },
    {
      "symbol": "ALRN",
      "name": "Aileron Therapeutics, Inc.",
      "change": 0.835,
      "price": 6.495,
      "changesPercentage": 14.7673
    },
    {
      "symbol": "VUZI",
      "name": "Vuzix Corporation",
      "change": 0.205,
      "price": 1.625,
      "changesPercentage": 14.4366
    },
    {
      "symbol": "BSGM",
      "name": "BioSig Technologies, Inc.",
      "change": 0.0899,
      "price": 0.7199,
      "changesPercentage": 14.2676
    },
    {
      "symbol": "HALL",
      "name": "Hallmark Financial Services, Inc.",
      "change": 0.099,
      "price": 0.8,
      "changesPercentage": 14.1227
    },
    {
      "symbol": "BYRN",
      "name": "Byrna Technologies Inc.",
      "change": 1.85,
      "price": 15.06,
      "changesPercentage": 14.0045
    },
    {
      "symbol": "DCO",
      "name": "Ducommun Incorporated",
      "change": 6.625,
      "price": 55.205,
      "changesPercentage": 13.6373
    },
    {
      "symbol": "BTFX",
      "name": "Valkyrie Bitcoin Futures Leveraged Strategy ETF",
      "change": 5.31,
      "price": 44.43,
      "changesPercentage": 13.5736
    },
    {
      "symbol": "LGCL",
      "name": "Lucas GC Limited Ordinary Shares",
      "change": 0.29,
      "price": 2.43,
      "changesPercentage": 13.5514
    },
    {
      "symbol": "PIK",
      "name": "Kidpik Corp.",
      "change": 0.61,
      "price": 5.2,
      "changesPercentage": 13.4213
    },
    {
      "symbol": "BITX",
      "name": "Volatility Shares Trust - 2x Bitcoin Strategy ETF",
      "change": 6.325,
      "price": 53.775,
      "changesPercentage": 13.3172
    },
    {
      "symbol": "BCAN",
      "name": "BYND Cannasoft Enterprises Inc.",
      "change": 0.135,
      "price": 1.165,
      "changesPercentage": 13.1694
    },
    {
      "symbol": "GOEV",
      "name": "Canoo Inc.",
      "change": 0.2792,
      "price": 2.4092,
      "changesPercentage": 13.1636
    },
    {
      "symbol": "GRNQ",
      "name": "Greenpro Capital Corp.",
      "change": 0.17,
      "price": 1.47,
      "changesPercentage": 13.0769
    },
    {
      "symbol": "APVO",
      "name": "Aptevo Therapeutics Inc.",
      "change": 0.46,
      "price": 4.09,
      "changesPercentage": 12.9461
    },
    {
      "symbol": "CONL",
      "name": "GraniteShares ETF Trust - GraniteShares 1.5x Long COIN Daily ETF",
      "change": 7.76,
      "price": 70.42,
      "changesPercentage": 12.3843
    }
  ];

 